import { render, staticRenderFns } from "./px-notice.vue?vue&type=template&id=8f48162c&scoped=true&"
import script from "./px-notice.vue?vue&type=script&lang=ts&"
export * from "./px-notice.vue?vue&type=script&lang=ts&"
import style0 from "./px-notice.vue?vue&type=style&index=0&id=8f48162c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f48162c",
  null
  
)

export default component.exports